/* ============================================================
   variant-info —— 商详页按当前 variant 切换配送/尺寸面板
   ------------------------------------------------------------
   依赖：snippets/variant-info.liquid 输出的 DOM
     [data-variant-info]                 容器
     [data-variant-info-default]         默认显示的 variant id
     [data-variant-info-id]              每个 variant 的面板

   安装：在 layout/theme.liquid 的 </head> 前加一行
     <script src="{{ 'variant-info.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-variant-info]';
  var PANEL_SELECTOR = '[data-variant-info-id]';

  function panelsOf(root) {
    return root.querySelectorAll(PANEL_SELECTOR);
  }

  function show(root, variantId) {
    var target = variantId == null ? '' : String(variantId);
    var panels = panelsOf(root);
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-variant-info-id') !== target;
    }
  }

  function hasPanel(root, variantId) {
    var target = String(variantId);
    var panels = panelsOf(root);
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-variant-info-id') === target) return true;
    }
    return false;
  }

  function variantFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      return null;
    }
  }

  // URL 上的 ?variant= 可能属于别的商品（快速预览弹窗等），
  // 只有当前容器里确实有对应面板时才采用，否则回落到默认 variant。
  function syncFromUrl(root) {
    var fromUrl = variantFromUrl();
    var fallback = root.getAttribute('data-variant-info-default');
    show(root, fromUrl && hasPanel(root, fromUrl) ? fromUrl : fallback);
  }

  // 部分主题切换 variant 时只改 URL 不派发事件，
  // 这里把 pushState/replaceState 包一层转成事件，避免轮询。
  function patchHistory() {
    if (window.__variantInfoHistoryPatched) return;
    window.__variantInfoHistoryPatched = true;

    ['pushState', 'replaceState'].forEach(function (name) {
      var original = window.history[name];
      if (typeof original !== 'function') return;
      window.history[name] = function () {
        var result = original.apply(this, arguments);
        window.dispatchEvent(new Event('variantinfo:locationchange'));
        return result;
      };
    });
  }

  function init(root) {
    if (root.hasAttribute('data-variant-info-bound')) return;
    root.setAttribute('data-variant-info-bound', '');

    // 1) 主题原生事件：theme.js 在 [data-section-id] 容器上派发 variantChange
    var section = root.closest ? root.closest('[data-section-id]') : null;
    if (section) {
      section.addEventListener('variantChange', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        show(root, variant ? variant.id : null);
      });
    }

    // 2) URL 兜底：直接带 ?variant= 进入、浏览器前进后退、pushState
    ['popstate', 'variantinfo:locationchange'].forEach(function (name) {
      window.addEventListener(name, function () {
        syncFromUrl(root);
      });
    });

    syncFromUrl(root);
  }

  function initAll() {
    patchHistory();
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 主题编辑器中 section 重载后重新绑定
  document.addEventListener('shopify:section:load', initAll);
})();
